/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { StyledContainer, StyledTourRow } from './index.styled';

const ActivitySkeleton = () => {
	const getSkeleton = () => {
		const rows = [];
		for (let i = 0; i < 4; i += 1) {
			rows.push(
				<StyledTourRow>
					<div className="activity_content">
						<Skeleton />
					</div>
				</StyledTourRow>,
			);
		}
		return rows;
	};
	return (
		<StyledContainer>
			{getSkeleton().map((row, index) => (
				<React.Fragment key={index}>{row}</React.Fragment>
			))}
		</StyledContainer>
	);
};

export default ActivitySkeleton;
